import { CMSBoosterPages } from '__generatedTypes__/globalTypes'
import { PlatformSlug } from 'constants/consts'
import { getFeatureConfig } from 'platformConfig'
import { getBlogPagesConfig } from 'pagesNew/BlogPages/platformConfig'
import { isCrashCoursesAvailable } from 'pagesNew/CrashCourses/platformConfig'
import { isCommonElementsAvailable } from 'pagesNew/CommonElements/platformConfig'

export type TestimonialsPagesConfig = {
  homepage: boolean
  product: boolean
  upgradePage: boolean
  reviews: boolean
}

export const TESTIMONIALS_PAGES_CONFIG: Partial<Record<PlatformSlug, TestimonialsPagesConfig>> = {
  [PlatformSlug.DATBooster]: { homepage: true, product: true, upgradePage: true, reviews: false },
  [PlatformSlug.OATBooster]: { homepage: true, product: true, upgradePage: true, reviews: false },
  [PlatformSlug.DATCrusher]: { homepage: true, product: true, upgradePage: true, reviews: false },
  [PlatformSlug.INBDEBooster]: { homepage: true, product: true, upgradePage: true, reviews: false },
  [PlatformSlug.Admissions]: { homepage: true, product: true, upgradePage: true, reviews: false },
  [PlatformSlug.PATBooster]: { homepage: true, product: true, upgradePage: true, reviews: false },
  [PlatformSlug.CasperBooster]: { homepage: true, product: true, upgradePage: true, reviews: true },
  [PlatformSlug.NBDHEBooster]: { homepage: true, product: true, upgradePage: true, reviews: true },
  [PlatformSlug.CARSBooster]: { homepage: true, product: true, upgradePage: true, reviews: true },
  [PlatformSlug.NDEBCrusher]: { homepage: true, product: true, upgradePage: true, reviews: true },
  [PlatformSlug.DLOSCE]: { homepage: true, product: true, upgradePage: true, reviews: false },
  [PlatformSlug.GREBooster]: { homepage: true, product: true, upgradePage: true, reviews: false },
}

export const isTestimonialPageAvailable = (slug: PlatformSlug | undefined, page: CMSBoosterPages) => {
  if (!slug || !isCommonElementsAvailable(slug)) {
    return false
  }

  const pages = getFeatureConfig(TESTIMONIALS_PAGES_CONFIG, slug)
  if (!pages) {
    return false
  }

  switch (page) {
    case CMSBoosterPages.HomePage:
      return pages.homepage
    case CMSBoosterPages.Product:
      return pages.product
    case CMSBoosterPages.UpgradePage:
      return pages.upgradePage
    case CMSBoosterPages.Review:
      return pages.reviews
    case CMSBoosterPages.SuccessStory:
      return getBlogPagesConfig(slug)?.successStories === true
    case CMSBoosterPages.CrashCourses:
      return isCrashCoursesAvailable(slug)
    default:
      return false
  }
}
